function auditRecurringFormatter(recurrence) {
  if (recurrence.status === false) {
    return 'Does not recur'
  } else {
    let RecurringFormate = 'Every ' + recurrence.frequency + ' ' + recurrence.duration
    if (recurrence.occurrences !== 0 && recurrence.occurrences !== 999) {
      RecurringFormate += '; ' + recurrence.occurrences + ' times'
    }
    return RecurringFormate
  }
}

export default auditRecurringFormatter
